<template>
  <div v-if="loading">
        <loader></loader>
      </div>
      <div v-else>
        <h1>Workflow</h1>
        <hr>
        <div class="form">
          <div class="alert alert-warning" v-if="hasLinkedRequests">
            Já existem requisições vinculadas a este fluxo. Tomar cuidado com modificações nas <b>Zonas de Perigo</b>.
          </div>
          <div class="form-group">
            <label for="name">Nome</label>
            <input id="name" type="text" v-model="workflow.name" class="form-control" />
          </div>
          <div class="form-group">
            <label for="name">Descrição</label>
            <quill-editor id="description" v-model="workflow.description"
                      :config="editorConfig" class="comment_editor">
            </quill-editor>
          </div>
          <div class="panel" v-bind:class="{'panel-danger': hasLinkedRequests}">
            <div v-if="hasLinkedRequests" class="panel-heading">
              <b>Zona de Perigo</b>
            </div>
            <div class="panel-body">
              <div class="form-group" id="target-group">
                <label for="target">Grupo Alvo</label>
                <multiselect v-model="workflow.target" id="target" label="description" track-by="objectId" :options="groups" :showLabels=false placeholder="Selecione uma opção"></multiselect>
              </div>
              <div class="form-group" id="target-group">
                <label for="responsible">Grupo Responsável</label>
                <multiselect v-model="workflow.responsible" id="responsible" label="description" track-by="objectId" :options="groups" :showLabels=false placeholder="Selecione uma opção"></multiselect>
              </div>
              <div class="form-group" id="reqtype-group">
                <label for="reqType">Tipo de Requisição</label>
                <multiselect v-model="workflow.reqType" id="reqType" label="name" track-by="objectId" :options="reqTypes" :showLabels=false placeholder="Selecione uma opção"></multiselect>
              </div>
            </div>
          </div>
          <div class="form-group" id="startdate-group">
            <label>Início de Vigência</label>
            <datepicker v-model="workflow.startDate"
              v-on:cleared="onStartDateCleared"
              type="date"
              format="dd/MM/yyyy"
              language="pt-br"
              :clear-button=true
              input-class="form-control field-date">
            </datepicker>
          </div>
          <div class="form-group" id="enddate-group">
            <label>Fim de Vigência</label>
            <datepicker v-model="workflow.endDate"
              v-on:cleared="onEndDateCleared"
              type="date"
              format="dd/MM/yyyy"
              language="pt-br"
              :clear-button=true
              input-class="form-control field-date">
            </datepicker>
          </div>
          <div class="form-group">
            <label for="active">Ativo</label>
            <input id="active" type="checkbox" v-model="workflow.active" />
          </div>
          <div class="form-group">
            <label for="feedback">Permitir acompanhamento do usuário</label>
            <input id="feedback" type="checkbox" v-model="workflow.feedback" />
            <p class="text-muted">Define se o usuário alvo do workflow poderá acompanhar o processo passo a passo.</p>
          </div>
          <div class="form-group">
            <a @click="viewMoreOptions = !viewMoreOptions" class="more-options">Outras Opções</a>
          </div>
          <transition name="fade">
            <div v-if="viewMoreOptions">
              <div class="form-group row">
                <div class="col-md-4">
                  <label for="trammitButton">Texto do Botão "Tramitar"</label>
                  <input id="trammitButton" v-model="customizations.trammitButton" type="text" class="form-control" placeholder="Ex. Tramitar" />
                </div>
                <div class="col-md-4">
                  <label for="grantButton">Texto do Botão "Deferir"</label>
                  <input id="grantButton" v-model="customizations.grantButton" type="text" class="form-control" placeholder="Ex. Deferir" />
                </div>
                <div class="col-md-4">
                  <label for="denyButton">Texto do Botão "Indeferir"</label>
                  <input id="denyButton" v-model="customizations.denyButton" type="text" class="form-control" placeholder="Ex. Indeferir" />
                </div>
              </div>
              <div class="form-group">
                <label for="canSendInvites">Pode enviar Convites?</label>
                <input id="canSendInvites" v-model="customizations.canSendInvites" type="checkbox" />
              </div>
              <div class="form-group">
                <label for="canEdit">Pode editar a inscrição?</label>
                <input id="canEdit" v-model="customizations.canEdit" type="checkbox" />
              </div>              
              <div class="form-group">
                <label for="mailContact">Email para contato</label>
                <input id="mailContact" v-model="customizations.mailContact" type="email" class="form-control"/>
              </div>
              <div class="form-group">
                <label for="inviteEmailText">Texto do Email de Convites</label>
                <quill-editor id="inviteEmailText" v-model="customizations.inviteEmail"
                          :config="editorConfig" class="comment_editor">
                </quill-editor>
                <p class="text-muted">Você pode usar os parâmetros {NOME_CONVIDADO}, {NOME_WORKFLOW} e {DATA_EXPIRACAO} dentro do texto de E-mail.</p>
              </div>
              <div class="form-group">
                <label for="requestEndMessage">Texto da requisição submetida</label>
                <quill-editor id="requestEndMessage" v-model="customizations.requestEndMessage"
                          :config="editorConfig" class="comment_editor">
                </quill-editor>
              </div>
              <div class="form-group">
                <label for="limit_user_requests">Limitar Número de Requisições</label>
                <input id="limit_user_requests" v-model="customizations.hasUserRequestsLimit" type="checkbox" />
                <p class="text-muted">Deve existir um limite de requisições por usuário?</p>
              </div>
              <div class="form-group">
                <label for="limit_user_requests">Limite do Número de Requisições</label>
                <input id="limit_user_requests" class="form-control" v-model="customizations.userRequestsLimit" type="number" />
                <p class="text-muted">Quantidade de requisições por usuário. (Depende do campo "Limitar Número de Requisições")</p>
              </div>
              <div class="form-group">
                <label for="advanced">Informações Compartilhadas</label>
                <multiselect v-model="workflow.defaultSharedFields" :options="fields" :multiple="true"
                  :close-on-select="false" :clear-on-select="false" :hide-selected="true"
                  placeholder="Se não especificado, todos campos serão visíveis" label="name" track-by="objectId"></multiselect>
              </div>
            </div>
          </transition>
          <hr>
          <div class="form-group">
            <label for="tags">Tags</label>
            <input-tag :tags="workflow.tags"></input-tag>
            <p class="text-muted">Categorias do Workflow na página inicial.</p>
          </div>
          <hr>
          <div class="panel" v-bind:class="{'panel-danger': hasLinkedRequests}">
            <div v-if="hasLinkedRequests" class="panel-heading">
              <b>Zona de Perigo</b>
            </div>
            <div class="panel-body">
              <h3>Fluxo de processamento</h3>
              <steps :steps="steps" :editable="true" :linked-requests="hasLinkedRequests" :events="{addStep: addStep, removeStep: removeStep, addFieldsToTrammit: addFieldsToTrammit, addExtraActions: addExtraActions}" :groups="groups" ></steps>
            </div>
          </div>
        </div>
        <hr>
        <button id="btn-save" class="btn btn-primary" v-on:click="save">
          Salvar
        </button>
      </div>
</template>

<script>
  import { Parse, miniToastr } from '../Global'
  import { quillEditor } from 'vue-quill-editor'
  import Steps from './util/Steps'
  import Loader from './util/Loader'
  import Multiselect from 'vue-multiselect'
  import Datepicker from 'vuejs-datepicker'
  import InputTag from 'vue-input-tag'
  import { handleParseError } from './util/ErrorHandling'

  var Workflow = Parse.Object.extend('Workflow')
  var Step = Parse.Object.extend('Step')
  var FormField = Parse.Object.extend('FormField')
  var RequestType = Parse.Object.extend('RequestType')
  var Request = Parse.Object.extend('Request')
  const ADMIN_WORKFLOW = 'ADMIN_WORKFLOW'

  export default {
    components: {
      Steps,
      Loader,
      Multiselect,
      quillEditor,
      Datepicker,
      InputTag
    },
    data () {
      return {
        workflow: { target: {}, tags: [], customizations: {}, defaultSharedFields: [] },
        workflowParse: {},
        loading: false,
        hasLinkedRequests: false,
        viewMoreOptions: false,
        customizations: {},
        steps: [],
        groups: [],
        reqTypes: [],
        selectedGroup: null,
        fields: [],
        editorConfig: {
          placeholder: '',
          modules: {
            toolbar: [['bold', 'italic', 'underline', 'strike'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'color': [] }, { 'background': [] }],
            ['link', 'image']
            ]
          }
        }
      }
    },
    mounted () {
      let id = this.$route.params.id
      if (id) {
        this.getById(id)
      } else {
        let self = this
        self.workflowParse = new Workflow()
        self.steps = [{}]
        let queryGroup = new Parse.Query(Parse.Role)
        queryGroup.ascending('description')
        queryGroup.limit(10000)
        queryGroup.find().then(function (results) {
          self.groups = results.map(r => r.toJSON())
          let queryReqType = new Parse.Query(RequestType)
          queryReqType.ascending('name')
          queryReqType.equalTo('active', true)
          queryReqType.limit(10000)
          return queryReqType.find()
        }).then(function (results) {
          self.reqTypes = results.map(r => r.toJSON())
        }, function (error) {
          handleParseError(self, error)
        })
      }
    },
    methods: {
      loadFields (requestTypeId) {
        let self = this
        self.loading = true
        let params = {
          requestTypeId: requestTypeId
        }
        Parse.Cloud.run('requestFieldsInfo', params).then(results => {
          self.fields = results.fields
        }).fail(error => {
          handleParseError(self, error)
        })
      },
      onStartDateCleared () {
        this.workflow.startDate = null
      },
      onEndDateCleared () {
        this.workflow.endDate = null
      },
      getRoleName (obj) {
        let acl = obj.getACL()
        if (acl) {
          for (let attr in acl.toJSON()) {
            let spl = attr.split(':')
            if (spl.length > 1) {
              return spl[1]
            }
          }
        }
        return null
      },
      getById (id) {
        let queryGroup = new Parse.Query(Parse.Role)
        let querySteps = new Parse.Query(Step)
        let queryReqType = new Parse.Query(RequestType)
        let queryRequest = new Parse.Query(Request)
        let query = new Parse.Query(Workflow)
        query.include('reqType')
        query.include('target')
        query.include('responsible')
        let self = this
        this.loading = true
        query.get(id).done(result => {
          self.workflowParse = result
          self.workflow = result.toJSON()
          var querySharedFields = result.relation('defaultSharedFields').query()
          return querySharedFields.find()
        }).then(fields => {
          self.workflow.defaultSharedFields = fields.map(f => f.toJSON())
          self.customizations = self.workflow.customizations
          let startDate = self.workflow.startDate
          let endDate = self.workflow.endDate
          if (startDate) {
            self.workflow.startDate = new Date(startDate.iso)
          }
          if (endDate) {
            self.workflow.endDate = new Date(endDate.iso)
          }
          queryGroup.ascending('description')
          queryGroup.limit(10000)
          return queryGroup.find()
        }).done(result => {
          self.groups = result.map(r => r.toJSON())
          queryReqType.ascending('name')
          queryReqType.equalTo('active', true)
          queryReqType.limit(10000)
          return queryReqType.find()
        }).done(result => {
          self.reqTypes = result.map(r => r.toJSON())
          querySteps.equalTo('workflow', self.workflowParse)
          return querySteps.find()
        }).done(results => {
          self.steps = results.map(r => r.toJSON())
          queryRequest.equalTo('status', 'processing')
          queryRequest.equalTo('workflow', self.workflowParse)
          return queryRequest.count()
        }).done(count => {
          self.hasLinkedRequests = count > 0
          this.loadFields(self.workflow.reqType.objectId)
        }).fail((error) => {
          handleParseError(self, error)
        }).always(() => {
          self.loading = false
        })
      },
      save () {
        let self = this

        if (self.hasLinkedRequests) {
          let shouldSave = confirm('Tem certeza que deseja modificar o Workflow que já possui requisições vinculadas?')
          if (!shouldSave) {
            return
          }
        }
        if (!self.workflow.target || !self.workflow.responsible || !self.workflow.reqType) {
          miniToastr.warn('Selecione o Grupo Alvo & Responsável e o Tipo de Requisição')
          return
        }
        let startDate = self.workflow.startDate
        let endDate = self.workflow.endDate
        if (startDate && endDate) {
          startDate.setHours(0, 0, 0, 0)
          endDate.setHours(23, 59, 59, 59)
          if (startDate.getTime() > endDate.getTime()) {
            miniToastr.warn('A data de Início de Vigência não pode ser superior à de Fim de Vigência.')
            return
          }
        }
        if (self.steps.some(step => !step.target || !step.name || !step.description)) {
          miniToastr.warn('Todos os dados dos Passos devem ser preenchidos.')
          return
        }
        self.loading = true
        let props = ['name', 'description', 'active', 'feedback', 'startDate', 'endDate', 'tags']
        props.forEach(p => self.workflowParse.set(p, self.workflow[p]))
        if (!self.workflowParse.get('customizations')) {
          self.workflowParse.set('customizations', {})
        }
        // Customizacoes dos botoes e email
        let hasMoreOptions = false
        for (let field in self.customizations) {
          if (self.customizations[field]) {
            hasMoreOptions = true
          }
        }
        if (hasMoreOptions) {
          self.workflowParse.set('customizations', self.customizations)
        }
        if (self.workflow.defaultSharedFields) {
          var relation = self.workflowParse.relation('defaultSharedFields')
          self.fields.forEach(f => {
            var field = new FormField()
            field.id = f.objectId
            relation.remove(field)
          })
          self.workflow.defaultSharedFields.forEach(f => {
            var field = new FormField()
            field.id = f.objectId
            relation.add(field)
          })
        }
        let reqType = new RequestType()
        reqType.set('id', self.workflow.reqType.objectId)
        self.workflowParse.set('reqType', reqType)
        let target = new Parse.Role()
        target.set('id', self.workflow.target.objectId)
        let responsible = new Parse.Role()
        responsible.set('id', self.workflow.responsible.objectId)
        self.workflowParse.set('target', target)
        self.workflowParse.set('responsible', responsible)
        let acl = new Parse.ACL()
        acl.setRoleWriteAccess(ADMIN_WORKFLOW, true)
        acl.setRoleReadAccess(ADMIN_WORKFLOW, true)
        acl.setRoleReadAccess(self.workflow.target.name, true)
        acl.setRoleReadAccess(self.workflow.responsible.name, true)
        self.workflowParse.setACL(acl)
        this.workflowParse.save().then((obj) => {
          let stepsParse = []
          for (let i = 0; i < self.steps.length; i++) {
            let s = self.steps[i]
            let stepParse = new Parse.Object('Step')
            if (s.objectId) stepParse.set('id', s.objectId)
            let props = ['name', 'description']
            props.forEach(p => stepParse.set(p, s[p]))
            stepParse.set('workflow', self.workflowParse)
            if (s.target) {
              let roleTarget = new Parse.Role()
              roleTarget.set('id', s.target.objectId)
              stepParse.set('target', roleTarget)
              let acl = new Parse.ACL()
              acl.setRoleWriteAccess(ADMIN_WORKFLOW, true)
              acl.setRoleReadAccess(ADMIN_WORKFLOW, true)
              acl.setRoleReadAccess(s.target.name, true)
              stepParse.setACL(acl)
            }
            stepParse.set('order', i)
            stepsParse.push(stepParse)
          }

          Parse.Object.saveAll(stepsParse).then(() => {
            var queryStepsToBeDeleted = new Parse.Query('Step')
            queryStepsToBeDeleted.equalTo('workflow', self.workflowParse)
            queryStepsToBeDeleted.notContainedIn('objectId', stepsParse.map(s => s.id))
            return queryStepsToBeDeleted.find()
          }, (obj, error) => {
            miniToastr.error(obj.message)
          }).then((stepsToBeDeleted) => {
            return Parse.Object.destroyAll(stepsToBeDeleted)
          }).then(() => {
            miniToastr.success('Informações salvas')
            self.loading = false
            self.getById(obj.id)
            self.$router.replace({name: 'WorkflowDetail', params: {id: obj.id}})
          }, (error) => {
            self.loading = false
            handleParseError(self, error)
          })
        })
      },
      addStep (index) {
        if (this.steps === undefined) this.steps = []
        let fakeStep = {'name': null, 'description': null, target: null}
        this.steps.splice(index + 1, 0, fakeStep)
      },
      removeStep (index) {
        this.steps.splice(index, 1)
      },
      addFieldsToTrammit (step) {
        this.$router.push({name: 'StepFieldList', params: { stepId: step.objectId, action: 'trammit' }})
      },
      addExtraActions (step) {
        this.$router.push({name: 'StepActionList', params: { stepId: step.objectId }})
      }
    }
  }
</script>

<style lang="css">
.datepicker-clear-button {
  position: absolute;
  right: 13px;
  top: 7px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
.more-options {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// WorkflowDetail.vue?4f361f3a